// @flow
import WebComponent from '../src/webComponents/WebComponent';
import $ from 'jquery';
import 'typeahead.js/dist/typeahead.jquery';
import Bloodhound from 'typeahead.js/dist/bloodhound';

export default class Typeahead extends WebComponent {
	didMount() {
		const {
			typeaheadOptions,
			typeaheadLabel,
			typeaheadTarget,
			typeaheadUrl,
			typeaheadNotFoundLabel,
			typeaheadPrefetch,
		} = this.props;
		const self = this;

		$(typeaheadLabel).typeahead(
				typeaheadOptions,
				{
					source: new Bloodhound({
						datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
						queryTokenizer: Bloodhound.tokenizers.whitespace,
						remote: {
							url: typeaheadUrl,
							prepare: function (query, settings) {
								return {
									url: settings.url,
									data: {
										q: query
									},
									method: 'POST'
								};
							},
							transform: function (response) {
								return response.items;
							}
						},
						...(typeaheadPrefetch !== false) ? {prefetch: typeaheadUrl} : ''
					}),
					display: 'title',
					limit: Infinity,
					templates: {
						suggestion: function (item) {
							return '<div>' + item.title + '</div>'
						},
						notFound: function (item) {
							return '<div class="tt-suggestion tt-not-found">' + typeaheadNotFoundLabel + '</div>'
						}
					}
				})
				.on('typeahead:select', function (e, item) {
					$(typeaheadTarget).val(item.id).trigger('requestValidation');
					self.dispatchEvent({type: 'change'});
				})
				.on('typeahead:change', function(e){
					self.dispatchEvent({type: 'change'});
				})
				.on('blur', function (e) {
					$(typeaheadTarget).trigger('requestValidation');
				})
				.on('typeahead:asyncrequest', function (e) {
					self.element.classList.add('is-in-progress');
				})
				.on('typeahead:asynccancel, typeahead:asyncreceive', function (e) {
					self.element.classList.remove('is-in-progress');
				});

		const instance = $(typeaheadLabel).data('tt-typeahead');
		instance.input.onSync('queryChanged', function () {
			$(typeaheadTarget).val('');
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/Typeahead.js